
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.878 21.876c-4.569 0-8.288-3.703-8.288-8.253 0-4.55 3.719-8.253 8.288-8.253 4.57 0 8.29 3.703 8.29 8.253 0 4.55-3.72 8.253-8.29 8.253zm0-14.515c-3.47 0-6.289 2.807-6.289 6.262 0 3.455 2.82 6.262 6.29 6.262 3.469 0 6.288-2.807 6.288-6.262 0-3.455-2.82-6.262-6.289-6.262z"}})])
          )
        }
      }
    